import { classNames } from '@progress/kendo-react-common';
import { formatMoney } from 'functions';
import styles from './CurrencyValue.module.scss';

type Props = {
    className?: string,
    value: number
};

const CurrencyValue = ({ className, value }: Props) => (
    <span
        className={classNames(className)}
    >
        {formatMoney(value)}
    </span>
);

export default CurrencyValue;